/**
 * Pure filter constants — no ThirdPartyConfigs or icon imports.
 * Extracted from constants.ts for SSR bundle isolation.
 *
 * constants.ts re-exports these for backward compatibility.
 */

import { type EntityATI } from '@atlassian/search-client/common/types';

export const CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES: EntityATI[] = [
	'ati:cloud:confluence:comment',
	'ati:cloud:confluence:attachment',
] as const;

/**
 * @returns an array of disabled ATIs in the 'All' types and 'All products' filter state, if there are any
 */
export const notRequestedATIsInAllSearch = (): EntityATI[] => [
	...CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES,
];
